const MAX_PROMPT_ROWS = 50;

const sumNumericColumns = (rows, columns) => {
  const totals = {};

  columns.forEach((column) => {
    let count = 0;
    let sum = 0;

    rows.forEach((row) => {
      const value = row?.[column];
      if (typeof value === "number" && Number.isFinite(value)) {
        count += 1;
        sum += value;
      }
    });

    if (count > 0) {
      totals[column] = { count, sum: Number(sum.toFixed(2)) };
    }
  });

  return totals;
};

// Uploaded Excel files can hold thousands of rows; injecting them verbatim into the
// AI prompt explodes token usage. Small files pass through untouched, large ones are
// reduced to a row sample plus full-dataset numeric totals so aggregates stay exact.
export const buildExcelPromptPayload = (excelData) => {
  if (!Array.isArray(excelData) || excelData.length === 0) {
    return null;
  }

  if (excelData.length <= MAX_PROMPT_ROWS) {
    return excelData;
  }

  const sampleRows = excelData.slice(0, MAX_PROMPT_ROWS);
  const columns = Object.keys(sampleRows[0] || {});

  return {
    truncated: true,
    totalRows: excelData.length,
    sampledRows: sampleRows.length,
    columns,
    numericTotalsAllRows: sumNumericColumns(excelData, columns),
    rows: sampleRows,
  };
};
